import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'

/* assets */
import CMLLogoLight from 'public/assets/influencer/images/cml-logo-light.png'
import CMLLogoDark from 'public/assets/influencer/images/cml-logo-dark.png'
import { ReactComponent as InstagramIcon } from 'public/assets/influencer/icons/social/Instagram.svg'
import { ReactComponent as TwitterIcon } from 'public/assets/influencer/icons/social/Twitter.svg'
import { ReactComponent as LinkedInIcon } from 'public/assets/influencer/icons/social/Linkedin.svg'
import { ReactComponent as PepperLogo } from 'public/assets/icons/PepperLogo.svg'

interface Props {
  theme?: 'dark' | 'light'
}

function CMLFooter({ theme = 'light' }: Props) {
  return (
    <section
      className={clsx(theme === 'dark' ? 'bg-black text-white' : 'bg-white')}
    >
      <div className="container py-9 md:py-28">
        <div className="mb-8 md:mb-9">
          <Image
            src={theme === 'light' ? CMLLogoLight.src : CMLLogoDark.src}
            alt="Global Marketing Leaders 2023"
            width={CMLLogoLight.width}
            height={CMLLogoDark.height}
            className="max-w-[16rem] lg:max-w-[20rem] w-full | mb-3"
          />
          <div className="flex items-center gap-2 | text-blue-50">
            Powered by
            <PepperLogo
              className="relative -top-2"
              style={{ width: 169, height: 32 }}
            />
          </div>
        </div>

        <div className="flex flex-col md:flex-row gap-12 md:gap-4 justify-between md:items-center">
          <p className="font-medium text-gray-70 tracking-wider leading-5 | max-w-3xl">
            <strong className="font-bold">
              Global Marketing Leaders 2023{' '}
            </strong>
            by Pepper Content is an exclusive curation of the brightest minds
            who have revolutionized the world of marketing. These visionaries
            have pushed the boundaries, disrupted the status quo, and
            transformed the way we approach content and marketing. Check out the
            full exhibit to be informed and inspired by the insights shared by
            these trailblazers.
          </p>

          <div className="flex gap-7 md:gap-10 lg:col-start-9 lg:col-end-12">
            <Link
              href={'https://www.instagram.com/pepper_content/'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <InstagramIcon
                color={clsx(theme === 'light' ? '#7566FF' : '#D4BBF6')}
                className="h-7 w-7 lg:h-10 lg:w-10"
              />
            </Link>

            <Link
              href={'https://twitter.com/Pepper_Content'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <TwitterIcon
                color={clsx(theme === 'light' ? '#7566FF' : '#D4BBF6')}
                className="h-7 w-7 md:h-10 md:w-10"
              />
            </Link>

            <Link
              href={'https://www.linkedin.com/company/peppercontent/'}
              target="_blank"
              rel="noopener noreferrer"
            >
              <LinkedInIcon
                color={clsx(theme === 'light' ? '#7566FF' : '#D4BBF6')}
                className="h-7 w-7 md:h-10 md:w-10"
              />
            </Link>
          </div>
        </div>
      </div>
    </section>
  )
}

export default CMLFooter
